<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'Success' | translate }}</h4>
</div>
<div class="modal-body pb-0">
  <div
    *ngIf="activityStore.submitProofThankYouMessage$ | async as message"
    [innerHTML]="message || defaultMessage"
  ></div>
</div>
<div class="modal-footer pt-0">
  <button class="btn btn-primary" type="submit" (click)="activeModal.close()">
    {{ 'Close' | translate }}
  </button>
</div>
